<template>
    <div>
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 mb-3"
        >
            <div class="title">
                <h1 class="mb-0">Payment</h1>
            </div>
        </div>
        <b-card footer-class="p-0" class="rounded-lg side-tab">
            <div class="tab-body row">
                <div class="col-12 col-md-2 tabs d-md-block">
                    <div class="w-100 d-flex d-md-block nav-scrollable">
                        <div
                            class="text"
                            v-for="tab in tabs"
                            :key="tab.id"
                            :class="{ active: tab.id == selectedTab }"
                            :id="'nav-' + tab.id"
                            @click="switchTab(tab.id)"
                            v-show="tab.isShow"
                        >
                            {{ tab.label }}
                        </div>
                    </div>
                </div>
                <div v-if="isLoading" class="col-md-10">
                    <loader-list />
                </div>
                <div v-else id="tab-details" class="col-md-10">
                    <div>
                        <div
                            v-if="selectedTab == 'payment_portal'"
                            class="onboarding"
                            id="onboarding"
                            style="height: 900px;"
                        ></div>
                        <DeviceList v-else-if="selectedTab == 'device_list'" />
                        <BNPLList
                            v-else-if="selectedTab == 'buynowpaylater'"
                            :bnplPaymentType="bnplPaymentType"
                            :openSunbitConfigModal="openSunbitConfigModal"
                        />
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import Payment from "@/services/payment";
import DeviceList from "@/components/payments/device/device-list.vue";
import BNPLList from "@/components/payments/buy-now-pay-later-list.vue";
import LoaderList from "@/components/elements/loader-list";
import PaymentType from "@/constants/payment-type";
import EXTENSIONS from "@/constants/extensions";
import Account from "@/services/account";

export default {
    components: {
        DeviceList,
        BNPLList,
        LoaderList
    },
    data() {
        return {
            tabs: [
                {
                    id: "payment_portal",
                    label: "Payment Portal",
                    isShow: true
                },
                {
                    id: "device_list",
                    label: "Device List",
                    isShow: true
                },
                {
                    id: "buynowpaylater",
                    label: "Buy Now Pay Later",
                    isShow: false
                }
            ],
            selectedTab: "payment_portal",
            isLoading: true,
            bnplPaymentType: null,
            openSunbitConfigModal: false
        };
    },
    watch: {},
    computed: {},
    mounted: async function () {
        const script = document.createElement("script");
        script.src =
            "https://onboarding.daysmartpayments.com/assets/dsp-onboarding.js";
        script.async = true;

        document.body.appendChild(script);

        script.onload = () => {
            this.getOnboardingFrame();
        };

        const sunbitConfig = this.$route.query?.sunbitConfig;
        if (sunbitConfig) {
            this.openSunbitConfigModal = true;
            //clear the query params
            this.$router.replace({ query: {} });
        }
    },
    async created() {
        if (await Account.checkExtensionsEnabled(EXTENSIONS.CODE.CODE_STRIPE)) {
            let bnpl = await Payment.getBnplPaymentType({
                bnplType: PaymentType.TYPE.NAME_BNPL_SUNBIT,
                ignoreStatus: true
            });
            if (bnpl?.message?.code == 200) {
                this.bnplPaymentType = bnpl.resources;
                this.tabs[2].isShow = true; // show BNPL tab
                if (this.openSunbitConfigModal) {
                    this.switchTab("buynowpaylater");
                    if (this.bnplPaymentType.status !== 1) {
                        this.openSunbitConfigModal = false;
                    }
                }
            }
        }
    },
    methods: {
        async switchTab(tabId) {
            this.selectedTab = tabId;
            switch (tabId) {
                case "payment_portal":
                    this.getOnboardingFrame();
                    break;
                case "device_list":
                    break;
                case "buynowpaylater":
                    try {
                        let bnpl = await Payment.getBnplPaymentType({
                            bnplType: PaymentType.TYPE.NAME_BNPL_SUNBIT,
                            ignoreStatus: true
                        });
                        if (bnpl.message.code === 200) {
                            this.bnplPaymentType = bnpl.resources;
                        }
                    } catch (error) {
                        console.error(
                            "Error fetching BNPL payment type:",
                            error
                        );
                    }
                    break;
            }
        },
        async getOnboardingFrame() {
            this.isLoading = true;
            let onboarding = [];
            let response = await Payment.getOnboardingData();

            if (response.code == 200) {
                // eslint-disable-next-line no-undef
                onboarding = new DaySmartPaymentsOnboarding({
                    token: response.params.token,
                    merchantId: response.params.merchantId,
                    dev: response.params.environment
                });

                if (onboarding) {
                    this.isLoading = false;
                    onboarding.element("#onboarding");
                }
            } else {
                this.isLoading = false;
                this._message(response.message, "danger");
                window.location = process.env.APPS + "business/business";
            }
        }
    }
};
</script>

<style scoped>
.card-body {
    min-height: 600px;
}
</style>
